import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { DistributorParams } from 'src/app/models/shared-dto';
import { Select2Data } from 'ng-select2-component';
import { UserService } from 'src/app/services/user.service';
import { KpiService } from 'src/app/services/kpi.service';
import { SharedService } from 'src/app/services/shared.service';
import { RenaultKpiGlobalFilter } from 'src/app/models/renault-kpi-filter-model';
import { combineLatestWith } from 'rxjs';
import { KpiWorkshopType } from 'src/app/helpers/enum';
import Swal from 'sweetalert2';
import { Helpers } from 'src/app/helpers/helpers';
import { ToastrService } from 'ngx-toastr';
import { visibleContentAnimation } from 'src/app/animations';

@Component({
  selector: 'app-kpi-global-filters',
  templateUrl: './kpi-global-filters.component.html',
  animations: [visibleContentAnimation]
})
export class KpiGlobalFiltersComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  userIsRecsa = false;
  canViewGlobalFilters = false;
  distributorFilters: DistributorParams = new DistributorParams();
  monthSelected: string = '0';
  yearSelected: string = '0';
  brandSelected: string[] = [];
  paymentSelected: string = '0';
  activitySelected: string = '0';

  monthData: Select2Data = [];
  yearData: Select2Data = [];
  brandData: Select2Data = [];
  paymentData: Select2Data = [];
  activityData: any[] = [];

  globalFilters: RenaultKpiGlobalFilter = new RenaultKpiGlobalFilter();

  loadedFilters: boolean = false;
  showGlobalFilters: boolean = false;

  constructor(
    private userService: UserService,
    private sharedService: SharedService,
    private service: KpiService,
    private helper: Helpers,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    // this.service.resetGlobalFilters();
    // this.globalFilters = this.service.initGlobalFilters();
    const subscription = this.service.getGlobalFilters().subscribe(resp => {
      this.globalFilters = resp;
    });
    this.addSubscription(subscription);
    this.getUserData();
    this.loadfilters();
  }

  ngOnDestroy(): void {
    // Limpiar todas las suscripciones para evitar memory leaks
    this.subscriptions.forEach(sub => {
      if (sub && !sub.closed) {
        sub.unsubscribe();
      }
    });
    this.subscriptions = [];
  }

  getUserData() {
    const subscription = this.userService.getUserData().subscribe(resp => {
      if (resp == null) return;
      this.userIsRecsa = resp.AdminRecsa;
      this.canViewGlobalFilters = resp.Recsa;
    });
    this.addSubscription(subscription);
  }

  getDistributorFilter(event: DistributorParams) {
    this.distributorFilters = event;
  }

  loadfilters() {
    const months$ = this.sharedService.getMonths();
    const years$ = this.sharedService.getYears();
    const brands$ = this.service.getKpiActividadTallerBrand();
    const payment$ = this.service.getKpiActividadTallerPayment();

    const subscription = months$.pipe(combineLatestWith(years$, brands$, payment$))
      .subscribe(([months, years, brands, payments]) => {
        //MONTHS
        this.monthData = months;
        this.monthSelected = this.globalFilters.Month.toString();

        //YEARS
        this.yearData = years;
        this.yearSelected = this.globalFilters.Year.toString();

        //BRANDS
        this.brandData = brands;
        this.brandSelected = this.globalFilters.Brand;

        // DISTRIBUTOR
        this.distributorFilters = this.globalFilters.DistributorFilters;

        //PAYMENTS
        this.paymentData = payments;
        this.paymentData.unshift({ value: '0', label: 'TODOS' });
        this.paymentSelected = this.globalFilters.Payment;

        //ACTIVITY
        this.activityData.push(
          { value: '0', label: 'TODOS' },
          { value: KpiWorkshopType.Mecanica.toString(), label: 'MECÁNICA' },
          { value: KpiWorkshopType.Carroceria.toString(), label: 'CARROCERÍA' });
        this.activitySelected = this.globalFilters.Activity;
        this.loadedFilters = true;
        setTimeout(() => {
          this.helper.enableBsTooltips();
        });
      });
    this.addSubscription(subscription);
  }

  filter() {
    if (this.distributorFilters.Distributor.length == 0) {
      Swal.fire({
        icon: 'error',
        text: 'Debes seleccionar un distribuidor',
        buttonsStyling: false,
        customClass: {
          confirmButton: 'btn btn-outline-secondary'
        },
        confirmButtonText: 'Cerrar'
      });
      return;
    }
    this.setFilters();
    this.showGlobalFilters = false;
  }

  setFilters() {
    this.globalFilters.DistributorFilters = this.distributorFilters;
    this.globalFilters.Year = +this.yearSelected;
    this.globalFilters.Month = +this.monthSelected;
    this.globalFilters.Brand = this.brandSelected;
    this.globalFilters.Payment = this.paymentSelected;
    this.globalFilters.Activity = this.activitySelected;
    this.service.setGlobalFilters(this.globalFilters);
    this.toastr.success("Los filtros globales se han configurado correctamente.");
  }

  toggleGlobalFilters() {
    this.showGlobalFilters = !this.showGlobalFilters;
  }

  // Método helper para añadir suscripciones
  private addSubscription(subscription: Subscription): void {
    this.subscriptions.push(subscription);
  }

}
